module.exports = __webpack_public_path__ + "static/media/guinea-bissau.3a26d2f5.svg";